module.exports = __webpack_public_path__ + "img/zhipai.244b4ab3.svg";